import { Environments } from '@/config';
import { HELIX_UHN_PRODUCTION } from './helix-uhn.production';
import { HELIX_UHN_STAGING } from './helix-uhn.staging';

export const HELIX_UHN = import.meta.env.MODE === Environments.PROD ? HELIX_UHN_PRODUCTION : HELIX_UHN_STAGING;
